import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Import components
import Widget from './Widget';

//Import graphing component
import { Bar } from 'react-chartjs-2';

// Import styling
import '../../styles/GraphWidget.css';

class GraphWidget extends Component {
    constructor(props) {
        super(props);

        // Set the initial state for the graphing component
        this.state = {
            values: {
                labels: ["1", "2", "3", "4"],
                datasets: [{
                    type: 'bar',
                    label: 'Daily Usage Over Time',
                    data: [1, 2, 3, 4],
                    fill: true,
                    fillColor: '#60abf0',
                    tension: .1,
                    borderColor: "#60abf0",
                    pointBackgroundColor: '#0090f7',
                    borderWidth: 2,
                    pointRadius: 0,
                    pointHitRadius: 100
                },
                {
                    type: 'bar',
                    label: 'Tank Status2',
                    data: [4, 3, 2, 1],
                    fill: true,
                    fillColor: '#60abf0',
                    tension: .1,
                    borderColor: "#F44336",
                    pointBackgroundColor: '#0090f7',
                    borderWidth: 2,
                    pointRadius: 0,
                    pointHitRadius: 100
                }]
            },
            chartOptions: {
                // title: {
                //     display: true,
                //     text: 'Historical Tank Data(%)',
                //     fontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                //     fontColor: '#fff',
                //     fontStyle: 'regular'
                // },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 15,
                        bottom: 0
                    }
                },
                showLines: true,
                aspectRatio: 1,
                // animation: {
                //     duration: 3000 // general animation time
                // },
                // hover: {
                //     animationDuration: 3000 // duration of animations when hovering an item
                // },
                //responsiveAnimationDuration: 3000, // animation duration after a resize
                responsive: true,
                maintainAspectRatio: false,
                scaleShowGridLines: false,
                scales: {
                    xAxes: [{
                        ticks: {
                            fontFamily: "Didact Gothic, sans-serif",
                            fontSize: 11,
                            fontColor: "#ecf0f1"
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            fontFamily: "Didact Gothic, sans-serif",
                            fontSize: 11,
                            fontColor: "#ecf0f1",
                            suggestedMin: 0
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                },
                legend: {
                    display: false
                }
            }
        }
    }

    // Update the state based on changing props
    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            //Only update if the data has actually changed
            this.generateDatasets(nextProps);
        }
    }

    componentDidMount() {
        this.generateDatasets(this.props);
    }

    //Convert the data received in props to a format the graphing component likes
    generateDatasets(props) {
        let datasets = [];
        let labels = [];

        props.label.forEach(function (label) {
            labels.push(label)
        })

        //Create a dataset object that Chart.js understand
        props.data.forEach(function (data) {
            datasets.push({
                type: data.type,
                label: data.label,
                data: data.usage,
                fill: true,
                fillColor: "#3d9ceb",
                //backgroundColor: "#60abf0",
                tension: .1,
                borderColor: "#607D8B",
                borderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10
            }, {
                    type: data.type,
                    label: 'Water Collected (gl)',
                    data: data.harvesting,
                    fill: true,
                    fillColor: '#60abf0',
                    tension: .1,
                    borderColor: "#2196F3",
                    pointBackgroundColor: '#0090f7',
                    borderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10
                });
        }, this);

        // console.log(labels)
        // console.log(datasets)

        //Let the React wrapper for Chart.js update the view
        this.setState({
            values: {
                labels,
                datasets
            }
        });
    }

    render() {
        return (
            // Wrap the graphing component in the generic wrapper
            <Widget graph={true} changeGraph={this.props.changeGraph} heading={this.props.heading} colspan={this.props.colspan} rowspan={this.props.rowspan} loading={this.props.loading}>
                <div className="GraphWidget">
                    <Bar data={this.state.values} options={this.state.chartOptions} />
                </div>
            </Widget >
        );
    }
}

// Enforce the type of props to send to this component
GraphWidget.propTypes = {
    heading: PropTypes.string,
    colspan: PropTypes.number,
    rowspan: PropTypes.number,
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(PropTypes.object)
}

export default GraphWidget;